var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 37,
    viewBox: "0 0 49 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "613d5c4dc4abb8f5cdd44c44_ic-quote.svg",
    clipPath: "url(#clip0_13_143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE2\x80\x9C",
    d: "M39.8696 36.1721C45.3043 36.1721 49 32.6259 49 27.0378C49 22.0945 45.7391 18.8706 41.0652 18.8706C39.9783 18.8706 39.2174 19.0856 38.4565 19.0856C37.2609 19.0856 36.3913 18.1184 36.3913 16.8288C36.3913 12.6378 40.087 8.12436 48.2391 2.5363L47.0435 0.172119C34.4348 6.72734 29 14.4647 29 23.7064C29 31.3363 33.0217 36.1721 39.8696 36.1721ZM10.8696 36.1721C16.3043 36.1721 20 32.6259 20 27.0378C20 22.0945 16.7391 18.8706 12.0652 18.8706C10.9783 18.8706 10.2174 19.0856 9.45652 19.0856C8.26087 19.0856 7.3913 18.1184 7.3913 16.8288C7.3913 12.6378 11.087 8.12436 19.2391 2.5363L18.0435 0.172119C5.43478 6.72734 0 14.4647 0 23.7064C0 31.3363 4.02174 36.1721 10.8696 36.1721Z",
    fill: "#454545"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 36,
    fill: "white",
    transform: "translate(0 0.172119)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuote);
export default __webpack_public_path__ + "static/media/ic-quote.d044268eb7fc4b0b977c6501fe5dd216.svg";
export { ForwardRef as ReactComponent };